import React, { useState } from "react"
import { Input, StdModal } from "@omnichannel/egr-common-ui"
import styled from "styled-components"
import { useQuery } from "@apollo/client"
import { getPlacesByNameQuery } from "../gql/wishlist"
import { useDebounce } from "use-debounce"
import { Shimmer } from "../../helpers/omniElements"

const BaseBox = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
`
const FormMainBox = styled(BaseBox)``

const SearchMainBox = styled(BaseBox)`
  position: relative;
  min-height: 41rem;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0 0 1.6rem 0;
`

const ResultBox = styled(BaseBox)`
  margin-top: 1.2rem;
  flex-direction: column;
`
const ResultItemBox = styled(BaseBox)`
  width: 100%;
  min-height: 2rem;
  justify-content: flex-start;
  padding: 1rem 0.8rem 0 0.8rem;
`

const LabelBox = styled(BaseBox)`
  justify-content: flex-start;
  padding: 1.2rem 0 1.6rem 0;
  font-size: 1.2rem;
  border-bottom-style: solid;
  border-bottom-width: thin;
  border-bottom-color: #cccccc;
  cursor: pointer;
`

function DeliveryAddressSearch(props) {
  const [searchKey, setSearchKey] = useState("") //useState(props.formValues.deliveryAddress ? props.formValues.deliveryAddress : '')
  const [debouncedSearchTerm] = useDebounce(searchKey, 500)

  const { data, loading } = useQuery(getPlacesByNameQuery, {
    variables: {
      name: debouncedSearchTerm,
    },
  })

  let result
  if (!loading && data && data.getPlacesByName.length > 0) {
    const mmOnly = data.getPlacesByName.filter(place =>
      place.address.includes("Metro Manila")
    )
    //result = data.getPlacesByName.map(place => {
    result = mmOnly.map(place => {
      return (
        <ResultItemBox
          key={place.placeId}
          onClick={() => {
            props.setPlaceId(place.placeId)
            // props.setDeliveryAddress(place.address)
            props.setFormValues({
              ...props.formValues,
              deliveryAddress: place.address,
            })
            props.setErrors({ ...props.errors, deliveryAddress: "" })
            props.setShowModal(false)
          }}
        >
          <LabelBox>{place.address}</LabelBox>
        </ResultItemBox>
      )
    })

    // console.log("data::", result)
  }

  return (
    <SearchMainBox>
      <Input
        label="** Delivery serviceable area is within Metro Manila"
        placeholder="Enter street, village, condominium, barangay, or city"
        value={searchKey}
        id="deliveryAddressSearch"
        onChange={input => {
          // console.log("input.currentTarget.value", input.currentTarget.value)
          setSearchKey(input.currentTarget.value)
        }}
      />
      <ResultBox>
        {!loading ? (
          result
        ) : (
          <>
            <ResultItemBox key={1}>
              <Shimmer width="100%" height="3.6rem" />
            </ResultItemBox>
            <ResultItemBox key={2}>
              <Shimmer width="100%" height="3.6rem" />
            </ResultItemBox>
            <ResultItemBox key={3}>
              <Shimmer width="100%" height="3.6rem" />
            </ResultItemBox>
            <ResultItemBox key={4}>
              <Shimmer width="100%" height="3.6rem" />
            </ResultItemBox>
            <ResultItemBox key={5}>
              <Shimmer width="100%" height="3.6rem" />
            </ResultItemBox>
          </>
        )}
      </ResultBox>
    </SearchMainBox>
  )
}

function DeliveryAddressForm(props) {
  const [showModal, setShowModal] = useState(false)

  return (
    <FormMainBox>
      <div
        onClick={() => {
          if (!props.disabled) setShowModal(true)
        }}
        style={{ width: "100%" }}
      >
        <Input
          label="Delivery Address *"
          placeholder="Delivery Address"
          value={props.formValues.deliveryAddress}
          id="deliveryAddress"
          // onChange={props.handleChange}
          error={props.errors && props.errors.deliveryAddress}
          disabled={true}
          // onClick={() => setShowModal(true)}
          style={{ cursor: "pointer" }}
        />
      </div>

      {showModal && (
        <StdModal
          showModal={showModal}
          closeModal={() => {
            setShowModal(false)
          }}
          closeOnBackgroundTouch={true} //optional
          title={"Enter Delivery Address"}
          body={
            <DeliveryAddressSearch {...props} setShowModal={setShowModal} />
          } //optional
          isFullScreenOnMobile={false} //optional
          isFullScreen={false} //optional
          padding={"2rem 0"}
          centerContent={true}
          backgroundColor={"rgba(200,200,200, .2)"}
          style={{ boxShadow: "0 .2rem .4rem rgba(0,0,0, .2)" }}
        />
      )}
    </FormMainBox>
  )
}

export default DeliveryAddressForm
